import { AuthContext } from 'contexts/AuthContext'
import { useRouter } from 'next/router'
import React, { useContext } from 'react'

const benefits = [
  'Early Pick Up Hours',
  'Members Only Auctions',
  'Custom Alerts',
  'Early Bin Store Access',
]

const BidftaPlusCTA = () => {
  const { isAuthenticated, isSubscribed } = useContext(AuthContext) || {}
  const router = useRouter()

  const handleLogin = () => {
    sessionStorage.setItem('pageMarker', router.asPath)
    router.push('/account/login')
  }

  const onClick = () => {
    isAuthenticated
      ? router.push('/account/dashboard/saved-searches')
      : handleLogin()
  }

  return (
    <div className="flex flex-col items-center justify-center p-[20px] bg-bidfta-gray-white w-full md:w-1/2 gap-y-3 h-auto py-10 sm:h-[380px] md:h-[480px]">
      <p className="max-w-[320px] font-bold italic gap-y-5 leading-10 text-center text-bidfta-blue-dark text-[30px] sm:max-w-[491px] sm:text-[26px] md:text-[30px] xl:text-[32px]">
        {isSubscribed
          ? 'Welcome BidFTA+ Member! Your subscription is currently active.'
          : 'Subscribe to BidFTA+ to receive exclusive member only perks!'}
      </p>
      <ul className="list-none block sm:hidden md:hidden">
        {benefits.map((item, index) => (
          <li
            className="text-bidfta-blue-dark mb-6 mt-6 text-[16px] font-bold uppercase flex items-center gap-2"
            key={`${index}`}
          >
            <div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="19"
                height="30"
                viewBox="0 0 19 19"
                fill="none"
              >
                <path
                  d="M17.8389 8.1592V7.6592H17.3389H11.0385V1V0.5H10.5385H7.80511H7.30511V1V7.6592H1H0.5V8.1592V10.8209V11.3209H1H7.30511V18V18.5H7.80511H10.5385H11.0385V18V11.3209H17.3389H17.8389V10.8209V8.1592Z"
                  fill="#FECE62"
                  stroke="#FECE62"
                />
              </svg>
            </div>
            <span>{item}</span>
          </li>
        ))}
      </ul>
      <div className="text-bidfta-blue-backdrop-light font-bold text-[24px] text-center flex flex-col gap-y-5">
        {!isSubscribed && <span>only $2.99 / month</span>}
        <button
          onClick={onClick}
          type="button"
          className="bg-bidfta-blue-light rounded-full px-[90px] py-[15px] text-[21px] text-center shadow-lg font-extrabold text-bidfta-gray-white hover:bg-bidfta-teal-300 transition ease-in-out duration-500"
        >
          {isSubscribed ? 'MANAGE SUBSCRIPTION' : 'JOIN NOW'}
        </button>
      </div>
    </div>
  )
}

const BidftaPlusMemberPerks = () => {
  return (
    <div className="flex justify-center w-1/2 bg-bidfta-blue-backdrop-light items-center hidden sm:flex sm:h-[380px] md:h-[480px] sm:w-full md:w-1/2">
      <div className="flex flex-col gap-y-8">
        <h2 className="text-bidfta-gray-white text-2xl sm:text-[26px] md:text-35 font-extrabold uppercase">
          BidFTA+ Member Perks
        </h2>
        <ul className="list-none flex flex-col gap-y-10">
          {benefits.map((item, index) => (
            <li
              className="flex text-bidfta-blue-dark text-[28px] sm:text-[21px] md:text-[24px] xl:text-[28px] font-bold uppercase"
              key={`${index}`}
            >
              <svg
                className="mr-4 mt-1 sm:mt-[6px] sm:h-[20px] md:mt-[6px] md:h-[24px] xl:h-[30px]"
                xmlns="http://www.w3.org/2000/svg"
                width="35"
                height="35"
                viewBox="0 0 35 35"
                fill="none"
              >
                <path
                  d="M20.17 14.39H34.55V19.74H20.17V34.17H14.39V19.74H0V14.39H14.39V0H20.17V14.39Z"
                  fill="#FECE62"
                />
              </svg>
              {item}
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}

export const BidftaPlusHero = () => {
  return (
    <>
      <BidftaPlusCTA />
      <BidftaPlusMemberPerks />
    </>
  )
}
